class ModalHolder {
  constructor() {
    this.modals = [];
  }

  addInstance(instance) {
    this.modals.push(instance);
  }

  removeInstance(instance) {
    const index = this.modals.findIndex(x => x._uid === instance._uid);

    if (index > -1) {
      this.modals.splice(index, 1);
    }
  }

  popInstance(cb = null) {
    const instance = this.modals.pop();

    if (instance) {
      instance.close(cb);
    }
  }

  clear() {
    this.modals = [];
  }
}

const holder = new ModalHolder();
window.holder = holder;

export default holder;
